<template>
  <div class="hello">
    <div v-if="page.page.training.content">
      <vue-markdown v-bind:source="page.page.training.content"></vue-markdown>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store'
import VueMarkdown from 'vue-markdown'


export default {
  name: 'TrainingPage',
  computed: {
    ...mapState(['page'])
  },
  components: {
    VueMarkdown
  }
}
</script>
<style scoped>

</style>
